///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, kioskDiagnosticActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postKioskDiagnostic = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_DIAGNOSTIC(payload.idKioskProduction, payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(kioskDiagnosticActionCreators.postKioskDiagnosticSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskDiagnosticActionCreators.postKioskDiagnosticFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_KIOSK_DIAGNOSTIC, postKioskDiagnostic)
}

export default sagas
